import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSpinner } from '@fortawesome/free-solid-svg-icons';
import './CreateButton.css';

const CreateButton = ({ 
  onClick, 
  text = "Create", 
  className = "", 
  disabled = false,
  type = "button",
  showIcon = false,
  isLoading = false,
  ...rest
}) => {
  return (
    <button
      type={type}
      className={`createButton ${className}`}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {isLoading ? (
        <FontAwesomeIcon icon={faSpinner} spin className="createButton-icon" />
      ) : (
        showIcon && <FontAwesomeIcon icon={faPlus} className="createButton-icon" />
      )}
      {text}
    </button>
  );
};

export default CreateButton;
